import React from "react";
import "bootstrap/dist/css/bootstrap.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import Austral from "../../images/partners/Austral.svg";
import AWS from "../../images/partners/AWS.svg";
import Claro from "../../images/partners/Claro.svg";
import GCOA from "../../images/partners/GCOA.svg";
import ITBA from "../../images/partners/ITBA.svg";
import MaterDei from "../../images/partners/MaterDei.svg";
import MIT from "../../images/partners/MIT.svg";
import Samsung from "../../images/partners/Samsung.svg";
import SMG from "../../images/partners/SMG.svg";
import Telecom from "../../images/partners/Telecom.svg";

import "./Partners.css";

export const Partners = () => {
  const breakpoints = {
    320: {
      slidesPerView: 1,
    },
    480: {
      slidesPerView: 2,
    },
    640: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 4,
    },
  };
  const images = [
    MaterDei,
    Samsung,
    AWS,
    Austral,
    GCOA,
    MIT,
    Telecom,
    Claro,
    ITBA,
    SMG,
  ];
  return (
    <div id="partners">
      <div className="partners-container">
        <div className="partners-box">
          <h1>Partners</h1>
        </div>
        <div className="partners-box">
          <strong>¡Nos encanta trabajar en equipo!</strong>
          <br />
          Estas son las empresas e instituciones con las que estamos trabajando
          para darte lo mejor y crear un mundo más Senior Friendly.{" "}
        </div>
      </div>
      {/* CAROUSEL -------------------------------- */}
      <div className="partners-container">
        <div className="partners-slider">
          <Swiper
            breakpoints={breakpoints}
            loop={true}
            autoplay={{ delay: 0, disableOnInteraction: false }}
            speed={2000}
            slidesPerView="auto"
            spaceBetween={0}
            modules={[Autoplay, Pagination]}
            pagination={{ clickable: true }}
          >
            {images.map((image, index) => (
              <SwiperSlide
                key={index}
                className="carousel-item-custom"
              >
                <img
                  src={image}
                  alt={`provider-logo-${index}`}
                  className="carousel-image"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Partners;
